import React, { useState, useEffect } from "react";
import "./Portfolio.css";
import { PROJECTS } from "../../Utils/data";
import AOS from "aos";
import "aos/dist/aos.css";

function Portfolio() {
  const [projects, setProjects] = useState(PROJECTS);
  const filterProject = (categoryItem) => {
    const updatedItems = PROJECTS.filter((curElem) => {
      return curElem.category === categoryItem;
    });
    setProjects(updatedItems);
  };

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 200,
      easing: "ease-in-sine",
      delay: 50,
    });
  }, []);

  return (
    <section className="portfolio-projects" id="portfolio">
      <div className="projects-container">
        <div className="project-content">
          <h2 className="portfolio-title">My Projects</h2>
          <div className="portfolio-filters" data-aos="slide-right">
            <span
              className="portfolio-item"
              onClick={() => setProjects(PROJECTS)}
            >
              All
            </span>
            <span
              className="portfolio-item"
              onClick={() => filterProject("Frontend")}
            >
              Frontend
            </span>
            <span
              className="portfolio-item"
              onClick={() => filterProject("Backend")}
            >
              Backend
            </span>
          </div>
          <div className="portfolio-container">
            {projects.map((project, index) => {
              const { id, name, image, link, category, description } = project;
              return (
                <div className="project-card" key={id} data-aos="fade-left">
                  <img src={image} alt="Project Img" className="p-img" />
                  <h3 className="name">{name}</h3>
                  <div className="project-details">
                    <span className="category">{category}</span>
                    <p className="description">{description}</p>
                    <a href={link} className="project-btn">
                      <i className="project-btn-icon">View</i>
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
